<div class="space-y-2">
  <div
    class="course-image rounded-lg shadow-md overflow-hidden group-hover:shadow-xl transition-shadow duration-300"
  >
    <ng-container *ngIf="course?.participations?.length">
      <span
        class="absolute top-2 right-2 badge bg-green-500 text-white px-2 py-1 rounded text-xs font-bold uppercase z-10"
      >
        {{ course?.participations?.[0]?.progress === 100 ? 'Completed' : 'Enrolled' }}
      </span>
    </ng-container>
    <div class="aspect-w-16 aspect-h-9">
      <img
        class="object-cover w-full h-full rounded-lg duration-300"
        [src]="course?.thumb_path || 'assets/images/no-image.jpg'"
        [alt]="course?.title || 'No image available'"
        loading="lazy"
      />
    </div>
  </div>
  <div class="space-y-1 text-center">
    <p class="text-xs text-gray-600">
      <span class="font-bold uppercase"
        >CREDIT HOURS: {{ course?.completion_time ?? 0 }}
        {{ (course?.completion_time ?? 0) > 1 ? 'HOURS' : 'HOUR' }}</span
      ><br /><span class="uppercase">{{ course?.courseCreditTypes }}</span>
    </p>
  </div>
</div>
